import Api from "@/services/Api";

export default {
  getAll() {
    return Api().get("dashboardEtiquetas/getAll");
  },
  create(data) {
    return Api().post("dashboardEtiquetas/create", data);
  },
  update(data) {
    return Api().put("dashboardEtiquetas/update", data);
  },
  delete(id) {
    return Api().delete(`dashboardEtiquetas/delete/${id}`);
  }
};
